var render = function () {
  var _vm$value, _vm$value$summary, _vm$value4, _vm$value4$payment, _vm$value4$payment$ty, _vm$value5, _vm$value5$summary;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "summary",
    class: {
      'summary_hide-comment-on-mobile': _vm.hideCommentFieldOnMobile
    }
  }, [_c('OrderTotalPrice', {
    staticClass: "mb-15",
    attrs: {
      "total": _vm.total,
      "order": _vm.value,
      "delivery": _vm.delivery
    }
  }), _vm._v(" "), _vm.isUser ? _c('WriteOffBonuses', {
    staticClass: "mb-15",
    attrs: {
      "balance": _vm.total.bonus.balance,
      "allow-to-spend": _vm.allowBonusAmountToSpend,
      "disabled": !(_vm.allowBonusAmountToSpend > 0),
      "model-value": ((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : (_vm$value$summary = _vm$value.summary) === null || _vm$value$summary === void 0 ? void 0 : _vm$value$summary.bonusSpent) === _vm.allowBonusAmountToSpend && _vm.allowBonusAmountToSpend > 0
    },
    on: {
      "update:model-value": function ($event) {
        return _vm.onChange({
          bonusSpent: $event ? _vm.allowBonusAmountToSpend : 0
        });
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.isUser && !_vm.isAvailableBonusesPay ? _c('WriteOffBonusesInfo', {
    staticClass: "mb-20",
    attrs: {
      "active": _vm.allowBonusAmountToSpend > 0
    }
  }) : _vm._e(), _vm._v(" "), _c('UIActionList', {
    attrs: {
      "actions": {
        add: _vm.$api.order.addPromocode,
        remove: _vm.$api.order.removePromocode
      }
    },
    on: {
      "add:success": function ($event) {
        return _vm.onPromocodeSuccessAdd();
      },
      "add:error": function ($event) {
        return _vm.emitter.emit('apply-promocode', {
          status: 'error'
        });
      },
      "remove:success": function ($event) {
        return _vm.onPromocodeSuccessRemove($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$value2, _vm$value2$summary;

        var add = _ref.add,
            remove = _ref.remove;
        return [_c('div', [_c('FormElement', {
          attrs: {
            "title": "Промокод:",
            "error": add.error ? add.response.error.description : null
          }
        }, [_c('InputButton', {
          attrs: {
            "value": (_vm$value2 = _vm.value) === null || _vm$value2 === void 0 ? void 0 : (_vm$value2$summary = _vm$value2.summary) === null || _vm$value2$summary === void 0 ? void 0 : _vm$value2$summary.promocode,
            "state": add.status === 'initial' ? 'default' : add.status,
            "button-text": "Применить"
          },
          on: {
            "click": add.request,
            "input": function ($event) {
              return _vm.onChange({
                promocode: $event
              });
            }
          }
        })], 1), _vm._v(" "), _vm.couponList && _vm.couponList.length ? _c('PromocodeList', {
          staticClass: "mb-17",
          attrs: {
            "list": _vm.couponList
          },
          on: {
            "remove": remove.request
          }
        }) : _vm._e()], 1)];
      }
    }])
  }), _vm._v(" "), _c('Toggle', {
    staticClass: "mb-20 summary__comment-field",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var _vm$value3, _vm$value3$summary;

        var onClick = _ref2.onClick,
            isActive = _ref2.isActive;
        return [!isActive ? _c('span', {
          staticClass: "link link_dashed fz-14",
          on: {
            "click": onClick
          }
        }, [_vm._v("Оставить комментарий для заказа")]) : _vm._e(), _vm._v(" "), isActive ? _c('div', {
          staticClass: "summary__another-form"
        }, [_c('FormElement', {
          attrs: {
            "title": "Комментарий:",
            "hint-min-height": "0"
          }
        }, [_c('div', {
          staticClass: "summary__field form-element__field"
        }, [_c('Textarea', {
          attrs: {
            "value": (_vm$value3 = _vm.value) === null || _vm$value3 === void 0 ? void 0 : (_vm$value3$summary = _vm$value3.summary) === null || _vm$value3$summary === void 0 ? void 0 : _vm$value3$summary.commentary,
            "placeholder": "Особенности подъезда к вам или какие-то особенности заказа"
          },
          on: {
            "input": function ($event) {
              return _vm.onChange({
                commentary: $event
              });
            }
          }
        })], 1)])], 1) : _vm._e()];
      }
    }])
  }), _vm._v(" "), _vm.errors && Array.isArray(_vm.errors) ? _c('Note', {
    staticClass: "summary__error mb-25",
    attrs: {
      "theme": "reddish"
    }
  }, [_c('div', {
    staticClass: "h5 mb-8"
  }, [_vm._v("\n      Заполните:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "dash-list"
  }, _vm._l(_vm.errors, function (e) {
    return _c('div', {
      key: e.key,
      staticClass: "dash-list__item"
    }, [_vm._v("\n        " + _vm._s(e.key) + "\n      ")]);
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', [_vm.apiError ? _c('ErrorNote', {
    staticClass: "summary__note mb-15",
    attrs: {
      "error": _vm.apiError
    }
  }) : _vm._e(), _vm._v(" "), _vm.isUnavailableExist ? _c('Note', {
    staticClass: "summary__button-note mb-15 lh-18",
    attrs: {
      "theme": "reddish"
    }
  }, [_c('span', {
    staticClass: "b"
  }, [_vm._v("Некоторых товаров в заказе нет в наличии")]), _vm._v(", поэтому они не попадут в заказ\n    ")]) : _vm._e(), _vm._v(" "), _vm.button ? [_c('Button', {
    staticClass: "summary__button-mobile",
    attrs: {
      "data-e2e": "checkout-mobile-start",
      "theme": "red",
      "size": "49",
      "fluid": "",
      "border-radius": "4px",
      "disabled": _vm.isProceedCheckout
    },
    on: {
      "click": function ($event) {
        return _vm.emit('checkout');
      }
    }
  }, [_c('span', {
    staticClass: "summary__btn-text summary__btn-text_mobile"
  }, [_vm._v(" Перейти к оформлению ")])]), _vm._v(" "), _c('Button', {
    staticClass: "summary__button-desktop",
    attrs: {
      "data-e2e": "checkout",
      "theme": "red",
      "size": "49",
      "fluid": "",
      "border-radius": "4px",
      "loading": _vm.loading,
      "disabled": !_vm.isCheckOrder
    },
    on: {
      "click": function ($event) {
        return _vm.emit('checkout');
      }
    }
  }, [_c('span', {
    staticClass: "summary__btn-text summary__btn-text_desktop"
  }, [_vm._v("\n          " + _vm._s(((_vm$value4 = _vm.value) === null || _vm$value4 === void 0 ? void 0 : (_vm$value4$payment = _vm$value4.payment) === null || _vm$value4$payment === void 0 ? void 0 : (_vm$value4$payment$ty = _vm$value4$payment.type) === null || _vm$value4$payment$ty === void 0 ? void 0 : _vm$value4$payment$ty.id) === 21 ? 'Оплатить заказ' : 'Оформить заказ') + "\n        ")])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-15 fz-12 lh-15",
    class: {
      'summary__btn-privacy-hidden': _vm.hidePrivacyPolicyOnMobile
    }
  }, [_c('Checkbox', {
    attrs: {
      "checked": _vm.isPrivacyPolicyChecked
    },
    on: {
      "change": function ($event) {
        return _vm.emit('privacy-policy-status-update', $event);
      }
    }
  }, [_vm._v("\n        Согласен на\n        "), _c('nuxt-link', {
    staticClass: "link link_blue link_wu",
    attrs: {
      "to": "/about/personal-information/"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_vm._v("\n          обработку персональных данных\n        ")]), _vm._v("\n        в соответствии с\n        "), _c('nuxt-link', {
    staticClass: "link link_blue link_wu",
    attrs: {
      "to": "/privacy/"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_vm._v("\n          политикой конфиденциальности\n        ")]), _vm._v("\n        и\n        "), _c('nuxt-link', {
    staticClass: "link link_blue link_wu",
    attrs: {
      "to": "/about/terms-of-use/"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_vm._v("\n          пользовательским соглашением\n        ")])], 1)], 1), _vm._v(" "), _vm.isShowCallbackCheckbox ? _c('div', {
    staticClass: "mt-15 fz-12 lh-15",
    class: {
      'summary__btn-privacy-hidden': _vm.hidePrivacyPolicyOnMobile
    }
  }, [_c('Checkbox', {
    attrs: {
      "checked": (_vm$value5 = _vm.value) === null || _vm$value5 === void 0 ? void 0 : (_vm$value5$summary = _vm$value5.summary) === null || _vm$value5$summary === void 0 ? void 0 : _vm$value5$summary.callbackNeeded
    },
    on: {
      "change": function ($event) {
        return _vm.onChange({
          callbackNeeded: $event
        });
      }
    }
  }, [_vm._v("\n        Перезвоните мне для подтверждения\n      ")])], 1) : _vm._e()], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }